<template>
    <v-dialog v-model="dialog" max-width="900px">
        <template v-slot:activator="{on}">
            <a v-on="on"
               :class="dark && $vuetify.breakpoint.mdAndUp ? 'white--text': 'black--text'"
               style="text-decoration: underline">{{title}}</a>
        </template>
        <v-card>
            <v-card-title>
                <v-row no-gutters>
                    <v-col>{{title}}</v-col>
                    <v-col cols="auto">
                        <v-btn icon @click="dialog=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

            </v-card-title>
            <v-card-text v-html="text"></v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {
        name: 'FooterDialog',
        props: {
            title:String,
            text:String,
        },
        data: ()=>({
            dialog: false,
        }),
        computed: {
            ...mapGetters( ['dark'] ),
        },
    };
</script>

<style scoped>

</style>